import { Talent } from '../../Classes'

const tier6 = [
  null,
  null,
  new Talent(
    'Slaughter from the Shadows',
    'ability_rogue_slaughterfromtheshadows',
    ['Reduces the Energy cost of your Backstab by ', ' and your Hemorrhage by ', '.'],
    5,
    [
      [4, 8, 12, 16, 20],
      [1, 2, 3, 4, 5],
    ],
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    {
      isNew: true,
      isChanged: false,
      isMoved: false,
    }
  ),
  null,
]

export default tier6
